import React, { Component } from 'react';
import Reflux from 'reflux';
import { Card } from '@arnsbogroup/react-voicearchive'

class Panel extends Component {
  render() {
    return (
      <Card>
        {this.props.children}
      </Card>
    );
  }
}

export { Panel };
